module.exports = __webpack_public_path__ + "img/payu.e454fdbe.png";